<div class="links">
    <div class="admin-link customer"
         *ngIf="(isAuthorized | async) && !(isAdmin| async)">
        <span (click)="onAdminClick()">
            {{ "BUTTON.GOTO.ADMIN" | translate }}&nbsp;
            <i class="fal fa-cogs"
               aria-hidden="true">
            </i>
        </span>
    </div>
    <div class="admin-link"
         *ngIf="(isAdmin | async)">
        <span (click)="onCustomerClick()">
            {{ "BUTTON.GOTO.FRONT" | translate }}
        </span>
    </div>
</div>
